module.exports = __webpack_public_path__ + "static/media/Colette Ray Queen Headboard - 155 cm_Dark Brown.ee76e183.png";